import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let note_templates = useDataValue({
    context: 'note_templates',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'note_templates_tab',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      if (next.note_templates.length === note_templates.length) {
        next.note_templates = []
      } else {
        next.note_templates = note_templates.map(item => item.id)
      }
    })
  }
}
